import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AdvancePaymentForm from './advance-paymentForm';
import { getPublicRental } from "../../../data/loca/rentals";
import { advancePaymentCall, publishableKey } from "../../../data/loca/stripe";
import { getSignNowSignature } from "../../../data/loca/signnow";
import { IsNullOrEmpty } from "../../../services/CustomService";
import { calendarStrings } from '../../../services/calendarStrings';

import {
    useLoaderData
} from "react-router-dom";

import Moment from 'react-moment';
import 'moment/locale/fr';
export async function loader({ params }) {

    const rental = await getPublicRental(params.rentalId);

    let error = null;
    let ClientSecret = null;
    let Status = "SignatureOnly";
    let key = null;

    if ((rental?.advancePaymentAmount ?? 0) > 0) {
        let resp = await advancePaymentCall(params.rentalId);
        error = resp.error;
        ClientSecret = resp.clientSecret;
        Status = resp.status;

        let Key = await publishableKey();
        key = Key.key;
    }

    return { ClientSecret, Status, key, rental,  error, rentalId: params.rentalId };
}


export default function StripePayment() {
    const { ClientSecret, Status, key, rental, error, rentalId } = useLoaderData();
    const [signNowLoading, setSignNowLoading] = useState(false);
    const [signNowError, setSignNowError] = useState(null);
    const [signNowStatus, setSignNowStatus] = useState(null);
    const [signNowLink, setSignNowLink] = useState(null);
    const stripePromise = key ? loadStripe(key) : null;
    const formatEuroAmount = (amount) => Number(amount ?? 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
   
    const options = {
        clientSecret: ClientSecret
    };


    const loadSignNowSignature = async () => {
        setSignNowLoading(true);
        setSignNowError(null);
        try {
            const response = await getSignNowSignature(rentalId);
            setSignNowStatus(response.status ?? response.Status ?? null);
            setSignNowLink(response.signingUrl ?? response.SigningUrl ?? null);
            setSignNowError(response.error ?? response.Error ?? null);
        } catch (err) {
            setSignNowError("Impossible de récupérer la signature SignNow.");
        } finally {
            setSignNowLoading(false);
        }
    };

    const requiresSignature = rental?.signatureRequired;
    const requiresAdvancePayment = (rental?.advancePaymentAmount ?? 0) > 0;

    useEffect(() => {
        if (requiresSignature && !requiresAdvancePayment) {
            loadSignNowSignature();
        }
    }, [rentalId, requiresSignature, requiresAdvancePayment]);

    return (
        <div className="financialForm">
            <div id="thumbnail">
                {(!IsNullOrEmpty(rental.base64Picture)) ? (
                    <img className="depositImg" height="192" key={rental.publicId} alt={rental.name} src={rental.base64Picture || null} />
                ) : (
                    <div className="no-picture no-picture-large"></div>
                )}

                <div>
                    <h1>Location : {rental.name}</h1>

                  
                    <div id="thumbnail-form">
                        <label>Par :&nbsp;<b>{rental.clientFirstname} {rental.clientLastname}</b></label> ({rental.serviceName})
                        
                    </div>
                    <label>
                    Date :&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.startDate)}
                        </Moment>
                        &nbsp;jusqu'&agrave;&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.endDate)}
                        </Moment>

                    </label>

                    {Status === "Error" ? (
                        <h3>
                            {error}
                        </h3>
                    )
                        : (
                            <>
                        
                    <div className="contentForm"></div>
                    

                    {Status === "SignatureOnly" ? (
                        <>
                            {requiresSignature ? (
                                <div className="contentForm">
                                    <h2>Signature électronique (SignNow)</h2>
                                    <p>Merci de signer électroniquement le contrat de location via SignNow.</p>
                                    {(signNowError) && (
                                        <p className="text-danger">{signNowError}</p>
                                    )}
                                    <div className="field">
                                        <Button size="small" severity="secondary" label="Signer avec SignNow" icon="pi pi-external-link" disabled={!signNowLink} onClick={() => window.open(signNowLink, '_blank', 'noopener,noreferrer')} />
                                        <Button size="small" severity="secondary" label="Rafraîchir le statut" icon="pi pi-refresh" loading={signNowLoading} className="ml-2" onClick={loadSignNowSignature} />
                                    </div>
                                    <div className="field">
                                        <span>Statut SignNow : <b>{signNowStatus ?? "En attente"}</b></span>
                                    </div>
                                </div>
                            ) : (
                                <h2>Aucune signature électronique n'est requise.</h2>
                            )}
                        </>
                    ) : Status === "Created" ? (
                        <>
                            {requiresSignature && (
                                <div className="contentForm">
                                    <h2>Signature électronique (SignNow)</h2>
                                    <p>Après le dépôt de l'acompte, la procédure de signature électronique sera envoyée par SignNow.</p>
                                </div>
                            )}
                            <h2>Je paie mon acompte par carte</h2>
                            <p>Montant  : {formatEuroAmount(rental.advancePaymentAmount)}€</p>
                            <Elements stripe={stripePromise} options={options}>
                                <AdvancePaymentForm />
                            </Elements>
                        </>
                    ) 
                        : (
                            <>
                                <h2>Paiement effectué avec succès !</h2>
                                {requiresSignature && (
                                    <p>Signature électronique nécessaire pour finaliser la location.</p>
                                )}
                            </>
                        )}

                            </>
                        )}
                </div>
            </div>
        </div>
    )            
}
